import Toggle, {Size} from '@jetbrains/ring-ui/components/toggle/toggle'
import classNames from 'classnames'
import React from 'react'

import {pipelineDraft} from '../../../../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../../../../hooks/pipeline'
import useBooleanState from '../../../../../../hooks/useBooleanState'
import Actions from '../../../../Actions/Actions'
import {integrations} from '../Integrations.consts'
import IntegrationSettingsForm from '../IntegrationSettingsForm/IntegrationSettingsForm'

import styles from './Integration.css'

import {useAppDispatch} from 'src/hooks/react-redux'

type Props = {
  id: string
  jobId?: string
  type: string
  parameters: Record<string, string>
  isDeleted?: boolean
  isEnabled?: boolean
  unsaved?: boolean
}

function Integration({id, type, jobId, parameters, isDeleted, isEnabled = !isDeleted}: Props) {
  const pipelineId = usePipelineId()
  const [isEditing, enableEditing, disableEditing] = useBooleanState()
  const dispatch = useAppDispatch()

  const integration = integrations[type]
  const integrationClassNames = classNames(styles.integration, {
    [styles.disabled]: !isEnabled,
    [styles.deleted]: isDeleted,
  })

  if (integration == null) {
    return null
  }

  const content = (
    <div>
      <div className={styles.name}>{integration.displayName}</div>
      {integration.note && <div className={styles.note}>{integration.note(parameters)}</div>}
    </div>
  )

  return (
    <div className={integrationClassNames}>
      {!isEditing ? (
        <>
          {jobId != null ? (
            <Toggle
              className={styles.toggle}
              size={Size.Size16}
              checked={isEnabled}
              disabled={isDeleted}
              onChange={e =>
                dispatch(
                  pipelineDraft.actions.toggleIntegration({
                    id: parameters.displayName!,
                    pipelineId,
                    jobId,
                    disabled: !e.currentTarget.checked,
                  }),
                )
              }
            >
              {content}
            </Toggle>
          ) : (
            content
          )}
          <Actions
            className={styles.actions}
            deleted={isDeleted}
            onEditClick={enableEditing}
            onDeleteClick={() =>
              dispatch(
                pipelineDraft.actions.deleteIntegration({
                  id,
                  name: parameters.displayName!,
                  pipelineId,
                }),
              )
            }
            onRestoreClick={() => {
              dispatch(
                pipelineDraft.actions.restoreIntegration({
                  pipelineId,
                  id,
                }),
              )
            }}
          />
        </>
      ) : (
        <IntegrationSettingsForm
          id={id}
          type={type}
          parameters={parameters}
          onClose={disableEditing}
        />
      )}
    </div>
  )
}

export default React.memo(Integration)
